import {defaultTo, sortBy} from 'ramda';

import {MazdaDecisionItem} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

export const sortMazdaDecisionItemsBySequenceNumber = sortBy((item: MazdaDecisionItem | Nullish) =>
  defaultTo(Number.MAX_SAFE_INTEGER, item?.sequenceNumber)
);
